import { ACCOUNT_NOTIFICATION_SETTINGS_PATHS } from '@/shared/constants';

export const NOTIFICATION_SETTINGS_SECTIONS = ['general', 'alerts'] as const;

export type NotificationSettingsSection = (typeof NOTIFICATION_SETTINGS_SECTIONS)[number];

interface NotificationSettingsLocation {
    hash?: string;
    pathname: string;
    search?: string;
}

export interface CanonicalNotificationSettingsLocation {
    hash: string;
    pathname: string;
    search: string;
    section: NotificationSettingsSection;
}

const isNotificationSettingsSection = (value?: string | null): value is NotificationSettingsSection =>
    NOTIFICATION_SETTINGS_SECTIONS.includes(value?.toLowerCase() as NotificationSettingsSection);

export const resolveNotificationSettingsLocation = ({
    hash = '',
    pathname,
    search = '',
}: NotificationSettingsLocation): CanonicalNotificationSettingsLocation => {
    const relativePath = pathname.startsWith(ACCOUNT_NOTIFICATION_SETTINGS_PATHS.root)
        ? pathname.slice(ACCOUNT_NOTIFICATION_SETTINGS_PATHS.root.length)
        : '';
    const pathSegments = relativePath.split('/').filter(Boolean);
    const pathSection = pathSegments[0]?.toLowerCase();
    const searchParams = new URLSearchParams(search);

    searchParams.delete('tab');
    searchParams.delete('alert');

    const section = isNotificationSettingsSection(pathSection) ? pathSection : 'general';
    const normalizedSearch = searchParams.toString();
    const alertResourcePath = pathSegments.length === 2 ? pathSegments[1] : undefined;
    const canonicalPathname =
        section === 'alerts' && alertResourcePath
            ? alertResourcePath.toLowerCase() === 'new'
                ? ACCOUNT_NOTIFICATION_SETTINGS_PATHS.createAlert
                : ACCOUNT_NOTIFICATION_SETTINGS_PATHS.alert(alertResourcePath)
            : ACCOUNT_NOTIFICATION_SETTINGS_PATHS[section];

    return {
        hash,
        pathname: canonicalPathname,
        search: normalizedSearch ? `?${normalizedSearch}` : '',
        section,
    };
};
